import DisabledElement from './disabled-element';

export default DisabledElement;
